/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


app.controller('MainNavCtrl', ['$rootScope', '$scope', '$http', 'NetworkService', 'MainService', 'LogService', '$timeout', function ($rootScope, $scope, $http, networkService, MainService, LogService, $timeout) {

        LogService.start()
        $scope.showLoadingCircle = false;
        $scope.rating = {
          actualLevel:1,
          nextLevel: 2,
          levelPercent: 50}

          if(ISLOGGEDIN)
          {
            networkService.getMyLevelAndPoints(function (data) {
              $scope.rating = data;
              $timeout(function(){
                $scope.renderLevelChange();
              },2000)
            })

            networkService.getMitarbeiterDetails(UserId, function (data) {
              $scope.user = data
            })
          }

          $(document).ready(function(){
            try {
              var c = document.getElementById("lineCanvas");
              var ctx = c.getContext("2d");
            } catch (e) {

            } finally {

            }

          })
          $scope.openLevelPopUp = function($event)
          {
            $event.stopPropagation();
            $("#levelPopup").fadeIn();
          }

          $scope.closeLevelPopup = function()
          {
            $("#levelPopup").fadeOut();
          }

          $scope.renderLevelChange = function()
          {
            percent = $scope.rating.levelPercent
            $("#lineFiller").css("width", percent+"%");
          }

        $rootScope.$on("startLoad", function () {
            $scope.showLoadingCircle = true;
        })

        $scope.isGuest = function ()
        {
            var ret = false;
            if ($scope.email == "gastaccount.atlas@hosiwien.at")
            {
                ret = true;
            }

            return ret;
        }

        $rootScope.$on("endLoad", function () {
            $scope.showLoadingCircle = false;
        })

        $scope.hasNotificatin = false;
        email = MainService.getEmail();
        $scope.email = email
        $scope.showLoggout = true;
        networkService.getHighestPermission(function (data) {
            $scope.highestPermission = data.level;
            if (data.error == "20")
            {
                $scope.showLoggout = false;
            }
        })

        networkService.getNotifications(email, function (data) {
            if (data.done)
            {
                $scope.notifications = data.notifications
                if ($scope.notifications.length > 0)
                {
                    $scope.hasNotificatin = true
                    $scope.startNotificationInterval()
                }
            }
        });





        $scope.startNotificationInterval = function ()
        {
            $scope.notificationInterval = setInterval(function () {
                $(".notificatoinSign").fadeToggle()
            }, 700)
        }

        $scope.endNotificationInterval = function ()
        {

        }

        $scope.showBurgerMenue = function ()
        {
            $(".burgerMenueContent").fadeIn(100)
            if ($scope.hasNotificatin)
            {
                networkService.userHasSeenNotifications(email);
            }
        }

        $scope.openPage = function (name)
        {
            if ($scope.isGuest())
            {
                console.log("Guest are not allowed to open pages")
            } else
            {
                window.location.replace(name);
            }
        }

        $scope.openUserOverlay = function()
        {
          $("#profileNavOverlay").fadeIn()
        }

        /*$scope.hideBurgerMenue = function ()
        {
            $(".burgerMenueContent").fadeOut(100)
        }

        $(".burgerMenue").on("click", function (event) {
            event.stopPropagation();
            $scope.showBurgerMenue();
        })*/

        $scope.closeProfileNavOverlay = function ()
        {
            $("#profileNavOverlay").fadeOut(100)
        }

        $("#profileNavOverlay").on("click", function (event) {
            event.stopPropagation();
        })

        $('html').click(function () {
            $scope.closeProfileNavOverlay()
            $scope.closeLevelPopup();
        });

        $scope.addNote = function ()
        {
            networkService.addNote(MainService.getEmail(), $scope.noteModel);
        }
    }])
